import React, { useEffect, useState } from 'react';
import Draggable from 'react-draggable';
import { useDispatch } from 'react-redux';
import { submitMockTest } from '../../../../actions/mock-test';
import { randomPointInRect } from '../../../../helpers/utils';
import KatexViewer from '@/helpers/Katex';

//drag and drop text template
const TemplateDragText = ({ question, model, section }) => {
  const dispatch = useDispatch();
  const [origin, setOrigin] = useState({ x: 0, y: 0 });
  useEffect(() => {
    // console.log("Random Origins", origin)
  }, [origin]);
  var posX: any;
  var posY: any;
  var width: any;
  var height: any;
  useEffect(() => {
    var element = document.getElementById('text-drag-and-drop');
    var position = element.getBoundingClientRect();
    posX = position.left;
    posY = position.top / 100;
    width = position.width;
    height = position.height;
    console.log(randomPointInRect({ x: posX, y: posY, width, height }).y);
    setOrigin({
      x: randomPointInRect({ x: posX, y: posY, width, height }).x,
      y: randomPointInRect({ x: posX, y: posY, width, height }).y,
    });
  }, []);
  const handleDrag = (e, ui, index, ansId) => {
    var dragAnswers = {
      x_origin: parseInt(ui.lastX.toFixed(2)),
      y_origin: parseInt(ui.lastY.toFixed(2)),
      section,
      model,
      answer: ansId,
      question: question.id,
    };
    dispatch(submitMockTest(dragAnswers));
  };
  return (
    <div className="mock-test-question-wrapper">
      <div className="sl-item mt-3">
        <div className="question-title-group">
          <div className="number" id={`q-${question.q_no}`}>
            {question.q_no}
          </div>
        </div>
      </div>
      <div className="type_blank">
        <div className="question-title">
          {question?.instruction ? (
            <div className="d-flex instruction-question">
              <div
                dangerouslySetInnerHTML={{ __html: question?.instruction }}
                className="px-2"
              />
            </div>
          ) : (
            ''
          )}
          <p>
            {question?.has_expression ? (
              <KatexViewer text={question?.title} />
            ) : (
              question.title
            )}
          </p>
        </div>

        <div
          id="text-drag-and-drop"
          className="border"
          style={{
            backgroundImage: `url(${'https://s3.ap-south-1.amazonaws.com/test.learnsic.com/media/public/voice_uploads/2021_11_17_12_15_32_ielts.png'})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            height: '500px',
            maxWidth: '100%',
            // width: '700px',
            position: 'relative',
            overflow: 'auto',
            padding: '0',
            backgroundRepeat: 'no-repeat',
          }}
        >
          {(origin?.x > 0 || origin?.x < 0) &&
            (origin?.y > 0 || origin?.y < 0) &&
            question?.answer.map((each, index) => (
              <Draggable
                key={index}
                onStop={(e, ui) => handleDrag(e, ui, index, each.id)}
                bounds="parent"
                // defaultPosition={{
                //     x: origin.x,
                //     y: origin.y
                // }}
                defaultPosition={{ x: Math.random() + 100, y: Math.random() + 250 }}
              >
                <div className="drag-box move-cursor">
                  <div>{each.text}</div>
                </div>
              </Draggable>
            ))}
        </div>
      </div>
    </div>
  );
};

export default TemplateDragText;
